import { render, staticRenderFns } from "./SoonModal.vue?vue&type=template&id=56707332"
import script from "./SoonModal.vue?vue&type=script&lang=js"
export * from "./SoonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports